import { createFileRoute } from "@tanstack/react-router";
import { Maintenance } from "../../app/views/admin/maintenance";

export const Route = createFileRoute("/admin/maintenance")({
  component: Maintenance,
});
